import { baseApi } from "./baseApi";
import { setConceptSetData } from "../slices/EIPMapValueDefinition.slice";
import { createSelector } from "@reduxjs/toolkit";
import { SYSTEM_SUFFIX, CONCEPTS_SUFFIX } from "../../utils/constants";

export const conceptsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getConceptData: builder.query({
      query: (conceptSetId) => `/v2/concept-sets/${conceptSetId}`,
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(setConceptSetData(data));
        } catch (e) {
          console.log("execption", e);
        }
      },
    }),
    getAllDomain: builder.query({
      query: () => `/v2/concept-sets`,
    }),
  }),
});

export const { useLazyGetConceptDataQuery, useGetAllDomainQuery } = conceptsApi;

export const selectGetAllDomainData =
  conceptsApi.endpoints.getAllDomain.select();

export const selectSystemMap = createSelector(
  selectGetAllDomainData,
  (getAllDomainResult) => {
    const data = getAllDomainResult?.data ?? [];
    return data
      .filter(
        (concept) =>
          concept.system !== undefined && !concept.name.endsWith(SYSTEM_SUFFIX)
      )
      .map((concept) => {
        return {
          value: concept.system,
          conceptSetId: concept._id,
          domain: concept.name.replace(CONCEPTS_SUFFIX, ""),
        };
      });
  }
);

export const selectSystemByDomain = (domain) =>
  createSelector(selectSystemMap, (systems) => {
    if (!domain) return [];
    return [...systems]
      .filter((system) => system.domain === domain.label)
      .map((system, index) => {
        return {
          id: index,
          label: system.value,
          value: system.conceptSetId,
        };
      })
      .sort((a, b) => a.label.localeCompare(b.label));
  });

export const selectDomainMap = createSelector(
  selectGetAllDomainData,
  (getAllDomainResult) => {
    const data = getAllDomainResult?.data ?? [];
    return [...data]
      .sort((a, b) => a.name.localeCompare(b.name))
      .filter(function (item, pos, ary) {
        return (
          (!pos || item.name != ary[pos - 1].name) &&
          !item.name.endsWith(SYSTEM_SUFFIX)
        );
      })
      .map((concept, index) => {
        return {
          id: index,
          label: concept.name.replace(CONCEPTS_SUFFIX, ""),
          value: concept._id,
        };
      });
  }
);
